import React from 'react';
import { useAuth0 } from "@auth0/auth0-react";
import { useEffect } from "react";
import { setUserFromAuth0 } from 'redux/actions/UserActions';
import axios from 'axios';

const LogoutWithRedirect = (props) => {
    const { user, isAuthenticated, isLoading, logout } = useAuth0();
    let auth0IdToken = localStorage.getItem("auth0IdToken");

    useEffect(() => {
        (async () => {
            if (!isLoading) {
                if (user && user.email && auth0IdToken) {
                    try {
                        await axios.post("/logout", { email: user.email }, {
                            headers: {
                                Authorization: `${auth0IdToken}`,
                            },
                        })
                    }
                    catch (e) {
                        console.error("App logout error - oops this should not happen", e);
                    }
                }
                setUserFromAuth0();
                logout({ logoutParams: { returnTo: window.location.origin, federated: true } });
            }
        })();
    }, [isAuthenticated, isLoading]);

    return ("");
}

export default LogoutWithRedirect;